var map = {
	"./Equipment-Icon.png": 427,
	"./Products-Icon.png": 428,
	"./Segments-Icon.png": 429,
	"./Shelfy-Icon.png": 208,
	"./Shelfy-Logo.png": 190,
	"./Sticker-Icon.png": 430,
	"./ar-icon.png": 431,
	"./cross.png": 209,
	"./dotdotdot.png": 28,
	"./empty-preview.png": 44,
	"./image-icon.png": 432,
	"./landing-ipad.png": 433,
	"./logo copy.png": 434,
	"./logo-white.png": 435,
	"./logo.png": 436,
	"./nav-logo.png": 437,
	"./plus.png": 117,
	"./search.png": 438,
	"./see-it.png": 439,
	"./segments/asain.png": 192,
	"./segments/bakery.png": 193,
	"./segments/cafe.png": 194,
	"./segments/chicken.png": 195,
	"./segments/dairy.png": 196,
	"./segments/fastfood.png": 197,
	"./segments/fish.png": 198,
	"./segments/kebab.png": 199,
	"./segments/pizza.png": 200,
	"./segments/restaurant.png": 201,
	"./segments/sandwich.png": 202,
	"./segments/supermarket.png": 203,
	"./segments/sushi.png": 204,
	"./share-it.png": 440,
	"./show-it.png": 441,
	"./smudge-logo.png": 442,
	"./storelab-logo.png": 443,
	"./text-icon.png": 444
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 207;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*$
// module id = 207
// module chunks = 0